export default __webpack_public_path__ + "static/media/furniture.60b9bbe7.webp";